// extracted by mini-css-extract-plugin
export var editButton = "_kx-0";